{
  "title": "Company profile",
  "subtitle": "Who you are and how numbers and dates look across the app. Only admins can change this.",
  "subtitleReadOnly": "Who you are and how numbers and dates look across the app. You can read it; only admins can change it.",
  "lastChanged": "Last changed {{date}} by {{name}}",
  "seeHistory": "see history",
  "saved": "Company profile saved",
  "identity": {
    "title": "Identity"
  },
  "contact": {
    "title": "Contact",
    "bankHint": "Printed at the foot of invoices and delivery notes."
  },
  "regional": {
    "title": "Regional settings",
    "currencyHint": "Fixed in this version.",
    "currencyValue": "{{code}} · {{decimals}} decimals"
  },
  "fields": {
    "legalName": "Legal name",
    "tradeName": "Trade name",
    "taxId": "Tax ID (matricule fiscal)",
    "tradeRegisterNo": "Trade register no.",
    "address": "Address",
    "city": "City",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "currency": "Currency",
    "defaultLanguage": "Default language",
    "timezone": "Time zone",
    "dateFormat": "Date format",
    "numberFormat": "Number format",
    "fiscalYearStartMonth": "Fiscal year starts",
    "bankName": "Bank",
    "rib": "Bank account (RIB)"
  },
  "logo": {
    "alt": "Company logo",
    "upload": "Upload logo",
    "replace": "Replace logo",
    "remove": "Remove",
    "hint": "PNG, JPEG, WebP or SVG, up to 1 MB. Square works best.",
    "tooLarge": "This file is larger than 1 MB.",
    "saved": "Logo updated",
    "removed": "Logo removed"
  },
  "preview": {
    "title": "Preview",
    "subtitle": "This is how values will look for users who keep the default language:",
    "stockValue": "Stock value",
    "dateTime": "Date and time",
    "quantityKg": "Quantity in kg"
  },
  "saveBar": {
    "note": "Every change is saved in the activity log with the old and new value.",
    "undo": "Undo changes"
  },
  "history": {
    "title": "Profile history",
    "subtitle": "Every change, with the old and the new value.",
    "empty": "No change recorded yet."
  }
}
